import React, { useEffect, useState } from 'react';
import { FullScreenAnimationLoader } from 'src/App/Dashboards/Market/Components/Loaders';
import { callApi } from 'src/core/callApi';
import HostModal from '../OverviewPage/UtilityComponents/HostModal';
import { Alert, Box, Container, Modal } from '@mui/material';
import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
const IndividualHostPage = ({
  user,
  currency,
  isLoggedIn,
  subscriptionModalOpen,
  setSubscriptionModalOpen,
  handleOnSampleClick,
  isMobileScreen,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [hostData, setHostData] = useState<any>(null);
  const { hostID } = useParams<{ hostID: string }>();

  const getHostData = async (hostID: string) => {
    setHostData('loading');
    const url = 'https://xfs76ukxc5.execute-api.us-east-2.amazonaws.com/default/getTopHostDetails';
    const config = {
      queryParams: {
        hostID: hostID,
        returnUserAccess: true,
        apiType: 'v3'
      },
    };
    const response = await callApi(url, config, true);
    const hostData = response?.message;
    if (hostData) {
      setHostData(hostData);
    } else {
      setHostData('failed');
    }
  };

  useEffect(() => {
    getHostData(hostID);
  }, []);

  return (
    <>
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Container
          sx={{
            background: '#fff',
            position: 'absolute' as 'absolute',
            top: '0',
            right: '0',
            height: '100dvh',
            overflow: 'auto',
            width: isMobileScreen ? '100vw' : '70vw',
            maxWidth: 900,
            borderRadius: 4,
            boxShadow: 24,
            p: 4,
            outline: 'none',
          }}
          className={isMobileScreen ? 'safe-mobile-height' : ''}
        >
          {hostData === 'loading' && <FullScreenAnimationLoader />}
          {hostData === 'failed' && (
            <Typography variant="body1">
              <Alert severity="error">
                Only available for hosts with 5+ listings. This host doesn’t meet that requirement.
              </Alert>
            </Typography>
          )}
          {hostData && hostData.host && (
            <Box sx={{ width: '100%' }}>
              <HostModal
                open={true}
                onClose={() => {}}
                host={hostData.host}
                currency={currency}
                isMobileScreen={isMobileScreen}
                setHost={() => {}}
                handleOnSampleClick={() => {
                  handleOnSampleClick('expert');
                  setIsModalOpen(false);
                }}
                user={user}
                getTableComponent={() => <></>}
                returnModalBodyOnly={true}
                handleUnlockTopHosts={() => {}}
              />
            </Box>
          )}
        </Container>
      </Modal>
    </>
  );
};

export default IndividualHostPage;
